import { Dispatch, SetStateAction } from 'react';
import { ReactComponent as ActiveStep } from '../../../assets/icons/onboarding/OnboardingActiveStepIcon.svg';
import { ReactComponent as CompletedStep } from '../../../assets/icons/onboarding/OnboardingCompletedStepIcon.svg';
import { ReactComponent as InactiveStep } from '../../../assets/icons/onboarding/OnboardingInactiveStepIcon.svg';
import { StepIconContainer } from './styles';

const StepIconComponent: React.FC<{
  activeStep: number;
  index: number;
  setActiveStep: Dispatch<SetStateAction<number>>;
}> = ({ activeStep, index, setActiveStep }) => {
  const currentStepIcon = () => {
    if (activeStep === index) {
      return <ActiveStep />;
    }
    if (activeStep > index) {
      return <CompletedStep />;
    }
    return <InactiveStep />;
  };

  const onClickStepIcon = () => {
    setActiveStep(index);
  };

  return (
    <StepIconContainer disabled={activeStep <= index} onClick={activeStep > index ? onClickStepIcon : null}>
      {currentStepIcon()}
    </StepIconContainer>
  );
};

export default StepIconComponent;
